import React from 'react';
import { Badge } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { AtbdTopDropdwon } from './auth-info-style';
import { Popover } from '../../popup/popup';
import Heading from '../../heading/heading';


const NotificationBox = (props) => {
  const rtl = false;

  const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
      borderRadius: 6,
      backgroundColor: '#F1F2F6',
    };
    return <div style={{ ...style, ...thumbStyle }} props={props} />;
  };

  const renderTrackVertical = () => {
    const thumbStyle = {
      position: 'absolute',
      width: '6px',
      transition: 'opacity 200ms ease 0s',
      opacity: 0,
      [rtl ? 'left' : 'right']: '2px',
      bottom: '2px',
      top: '2px',
      borderRadius: '3px',
    };
    return <div className="hello" style={thumbStyle} />;
  };

  const renderView = ({ style, ...props }) => {
    const customStyle = {
      marginRight: rtl && 'auto',
      [rtl ? 'marginLeft' : 'marginRight']: '-17px',
    };
    return <div {...props} style={{ ...style, ...customStyle }} />;
  };

  renderThumb.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };

  renderView.propTypes = {
    style: PropTypes.shape(PropTypes.object),
  };

  const content = (
    <AtbdTopDropdwon className="atbd-top-dropdwon">
      <Heading as="h5" className="atbd-top-dropdwon__title">
        <span className="title-text">Notifications</span>
        <Badge className="badge-success" count={props.notifications && props.notifications.length} />
      </Heading>
      <Scrollbars
        autoHeight
        autoHide
        renderThumbVertical={renderThumb}
        renderView={renderView}
        renderTrackVertical={renderTrackVertical}
      >
        <ul className="atbd-top-dropdwon__nav notification-list">
          {
            props.notifications && props.notifications.map((notification) => (
              <li key={notification.id} onClick={() => props.markAsRead(notification.id)}>
                <Link to="#">
                  <div className="atbd-top-dropdwon__content notifications">
                    <div className="notification-icon bg-primary">
                      <FeatherIcon icon="hard-drive" />
                    </div>
                    <div className="notification-content d-flex">
                      <div className="notification-text">
                        <Heading as="h5">
                          {notification.title}
                        </Heading>
                        <p>{notification.body}</p>
                      </div>
                      <div className="notification-status">
                        <Badge dot />
                      </div>
                    </div>
                  </div>
                </Link>
              </li>
            ))
          }
        </ul>
      </Scrollbars>
    </AtbdTopDropdwon>
  );

  return (
    <div className="notification">
      <Popover placement="bottomLeft" content={content} action="click">
        {props.notifications && props.notifications.length > 0 ? (<Badge dot offset={[-8, -5]}>
          <Link to="#" className="head-example" style={{ color: "#FFF" }}>
            <FeatherIcon icon="bell" size={20}/>
          </Link>
        </Badge>) : (
          <Link to="#" className="head-example" style={{color: "#FFF"}}>
            <FeatherIcon icon="bell" size={20} />
          </Link>
        )}
      </Popover>
    </div>
  );
};

export default NotificationBox;
